import React from 'react';
import { LucideIcon } from 'lucide-react';

interface ConnectButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
    icon?: LucideIcon;
    children: React.ReactNode;
}

export const ConnectButton: React.FC<ConnectButtonProps> = ({
    icon: Icon,
    className,
    children,
    ...props
}) => {
    // Premium Honey-Gold Aesthetic (Warm solid gold gradient on idle, glorious bright gold on hover)
    const baseClasses = "relative group flex items-center justify-center gap-2 px-5 py-2.5 text-sm font-black transition-all duration-300 active:scale-95 hover:scale-[1.03] overflow-hidden isolate rounded-lg whitespace-nowrap border border-yellow-400/25 hover:border-yellow-300 cursor-pointer shadow-[0_4px_12px_rgba(0,0,0,0.3)]";
    const variantClasses = "bg-gradient-to-r from-amber-600 via-yellow-500 to-amber-500 hover:from-amber-500 hover:via-yellow-400 hover:to-amber-600 text-purple-950 shadow-[0_0_15px_rgba(245,158,11,0.2)] hover:shadow-[0_0_30px_rgba(251,191,36,0.6)]";

    const combinedClassName = `${baseClasses} ${variantClasses} ${className || ""}`;

    return (
        <button
            className={combinedClassName}
            {...props}
        >
            {/* Dynamic Shine Layer */}
            <div className="absolute inset-0 opacity-0 group-hover:opacity-100 pointer-events-none transition-opacity duration-700">
                <div className="absolute inset-0 bg-gradient-to-r from-transparent via-white/40 to-transparent -translate-x-full group-hover:animate-shine" />
            </div>

            {/* Internal Heat Glow */}
            <div className="absolute inset-x-0 bottom-0 h-1/2 bg-gradient-to-t from-white/20 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300" />

            <div className="relative z-10 flex items-center gap-2">
                {Icon && <Icon size={18} className="text-current group-hover:scale-110 transition-transform duration-300" />}
                {children}
            </div>
        </button>
    );
};
